import { createSlice } from "@reduxjs/toolkit";
import {
  createEmployeeAPI,
  getEmployeeManagerOptionsAPI,
  uploadEmployeeDocumentAPI,
} from "./employeeAPI";

const initialState = {
  employees: [],
  managerOptions: [],
  loading: false,
  uploadLoading: false,
  error: null,
};

const employeeSlice = createSlice({
  name: "employee",
  initialState,
  reducers: {
    clearEmployeeError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // CREATE EMPLOYEE
      .addCase(createEmployeeAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createEmployeeAPI.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createEmployeeAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // MANAGER OPTIONS
      .addCase(getEmployeeManagerOptionsAPI.pending, (state) => {
        state.error = null;
      })
      .addCase(getEmployeeManagerOptionsAPI.fulfilled, (state, action) => {
        state.managerOptions = action.payload.data || [];
      })
      .addCase(getEmployeeManagerOptionsAPI.rejected, (state, action) => {
        state.error = action.payload;
      })

      // FILE UPLOAD
      .addCase(uploadEmployeeDocumentAPI.pending, (state) => {
        state.uploadLoading = true;
      })
      .addCase(uploadEmployeeDocumentAPI.fulfilled, (state) => {
        state.uploadLoading = false;
      })
      .addCase(uploadEmployeeDocumentAPI.rejected, (state, action) => {
        state.uploadLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearEmployeeError } = employeeSlice.actions;
export default employeeSlice.reducer;
